/**
 * User: n.gorte
 * Date: 24.06.2022
 * Time: 12:30
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Button } from 'external/react-bootstrap';
import '../css/_header.scss';

export const Header = ({ onClose, children }) => {

    return (
        <div className="fliwas-header">
            {children}
            {
                onClose &&
                <Button
                    variant="outline-primary"
                    className="fliwas-header__button fliwas-header__button-close"
                    onClick={onClose}
                >
                    <span className="icon icon-map-x leaflet-sidebar__close-icon"/>
                </Button>
            }
        </div>
    );
};

Header.propTypes = {
    onClose: PropTypes.func,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
};



// WEBPACK FOOTER //
// ./js/components/Header.js